module.exports = __webpack_public_path__ + "media/images/athletes/2175-16c36b666754115beaa1667d28746041.png";